import { Component, OnInit, ViewChild } from '@angular/core';
import { MatStepper } from '@angular/material/stepper';
import { ActivatedRoute, Router } from '@angular/router';
import { ScrumboardService } from 'app/main/pages/scrumboard/scrumboard.service';
import { ActivityCenterService } from 'app/shared/common/helper/activity-center';
import { ParseService } from 'app/shared/common/parse/parse.service';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ProjectDataService } from './project-data.service';

@Component({
  selector: 'app-project-information',
  templateUrl: './project-information.component.html',
  styleUrls: ['./project-information.component.scss']
})
export class ProjectInformationComponent implements OnInit {
  @ViewChild('stepper', { static: false }) stepper: MatStepper;
  tenantId: '';
  userId: string;
  userName: string;
  projectId: string;
  defaultSprintId: any;
  resourceDetails = {
    id: this.getRandomNumber(9),
    resourceDetailDate: new Date()
  };

  constructor(
    private projectDataService: ProjectDataService,
    private parseService: ParseService,
    private storageConfiguration: StorageConfiguration,
    private activityCenterService: ActivityCenterService,
    private router: Router,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private _scrumboardService: ScrumboardService
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.projectId = params['id'];
    });
    this.tenantId = this.storageConfiguration.sessionGetItem(this.storageConfiguration.tenantId);
    this.projectDataService.saveProjectInfo.subscribe(data => {
      if (this.projectDataService.saveProjectStatus === false) {
        this.saveProject();
      }
    });
    this.projectDataService.updateProjectInfo.subscribe(data => {
      if (this.projectDataService.updateProjectStatus === false) {
        this.updateProject();
      }
    });
  }

  goForward(stepper: MatStepper): void {
    this.stepper.next();
  }

  goBack(stepper: MatStepper): void {
    this.stepper.previous();
  }



  constructResource = (array, key) => {
    return array.reduce((result, currentValue) => {
      (result[currentValue[key]] = result[currentValue[key]] || []).push(
        currentValue
      );
      return result;
    }, {});
  };

  async saveProject() {
    this.spinner.show();
    this.projectDataService.saveProjectStatus = true;
    const projectData = this.projectDataService.projectInformation;
    const assignMember = this.projectDataService.allocatedResource;
    const selectedBilling = this.projectDataService.selectedBilling;

    const Project = this.parseService.instance.Object.extend('Project');
    const project = new Project();
    const client = new this.parseService.instance.Object('Client');
    client.id = projectData.clientName.value;
    const details = [];
    const resourceGroup = await this.constructResource(assignMember, 'role');
    for (const [key, value] of Object.entries(resourceGroup)) {
      let hoursMonth = 0;
      resourceGroup[key].forEach(element => {
        let data = element.hours ? element.hours : element.months;
        return hoursMonth = hoursMonth + data;
      });

      const detailsObject = {
        "id": this.getRandomNumber(9),
        "role": key,
        "count": resourceGroup[key].length,
        "hours": hoursMonth
      }
      details.push(detailsObject);

    }
    this.resourceDetails['details'] = details;
    const data = {
      projectInfo: {
        clientName: projectData.clientName.value,
        projectDescription: projectData.projectDescription.value,
        projectName: projectData.projectName.value,
        // projectType: profileValues.projectType,
        addOnType: "",
        projectType: selectedBilling,
        currentStatus: 'New',
        projectPlatform: ["NodeJs", "Php", "Angular", "Angularjs", "AWS"],
        reason: '',
        projectStartDate: new Date(),
        actualCompletionDate: new Date(),
        extendedCompletionDate: new Date(),
        srs: [],
        plan: [],
      },
      resourceDetails: this.resourceDetails
    };
    project.set('resourceDetails', this.resourceDetails);
    project.set('projectInfo', data.projectInfo);
    project.set('client', client);
    project.set('comments', []);
    project.set('projectType', 'Project');
    project.set('isActive', true);
    project.set('assignMember', assignMember);
    const activities = [];
    const message = 'Created a Project ' + projectData.projectName.value;
    const activity = this.activityCenterService.setActivityModel(message);
    activities.push(activity);
    project.set('defaultProject', false);
    project.set('activities', activities);
    project.set('tenantId', this.tenantId);
    if (selectedBilling === 'Fixed Billable') {
      project.set('schedulerStatus', 'Fixed Billable');
    }
    else if (selectedBilling === 'Fixed Non-Billable') {
      project.set('schedulerStatus', 'Fixed Non-Billable');
    }
    else if (selectedBilling === 'Time and Material Billable') {
      project.set('schedulerStatus', 'Time and Material Billable');
    }
    else if (selectedBilling === 'Time and Material Non-Billable') {
      project.set('schedulerStatus', 'Time and Material Non-Billable');
    }
    else {
      project.set('schedulerStatus', '');
    }
    project.save().then(async (project) => {
      const projectId = project.id;
      const projectType = project.attributes.projectType;
      await this._scrumboardService.createScrumBoard(projectId, false).then(data => {
        this.defaultSprintId = data.id;
      });
      await this.assignProject(projectId, assignMember, selectedBilling, projectType);
      this.router.navigate(['project-detail', { id: projectId, projectType: projectType }]);
      this.toastr.success('Project Created and Members Assigned Successfully');
      this.spinner.hide();
    });
  }

  assignProject(projectId, assignMember, selectedBilling, projectType) {
    assignMember.forEach(async element => {
      await this.getUser(element);
      let ProjectClass = this.parseService.instance.Object.extend('ProjectMembers');
      var projectDetails = new ProjectClass();
      projectDetails.set('project', { __type: 'Pointer', className: 'Project', objectId: projectId });
      projectDetails.set('startDate', new Date());
      projectDetails.set('endDate', new Date());
      projectDetails.set('resourcesType', selectedBilling.value);
      projectDetails.set('username', this.userName);
      projectDetails.set('isActive', true);
      projectDetails.set('isInvited', false);
      projectDetails.set('status', 'Assigned');
      projectDetails.set('role', element.role);
      projectDetails.set('tenantId', this.tenantId);
      projectDetails.set('user', { __type: 'Pointer', className: '_User', objectId: this.userId });
      projectDetails.save();
    });
  }

  async getUser(element) {
    let User = this.parseService.instance.Object.extend('_User');
    let query = new this.parseService.instance.Query(User);
    query.equalTo('profile', { __type: 'Pointer', className: 'Profile', objectId: element.resource.profileId });
    let invitedUser = await query.find();
    this.userId = invitedUser[0].id;
    this.userName = invitedUser[0].attributes.username;
  }

  getRandomNumber(val) {
    const timestamp = +new Date();
    length = val;
    var ts = timestamp.toString();
    var parts = ts.split('').reverse();
    var id = '';

    for (var i = 0; i < length; ++i) {
      var index = this.generateRandomNumber(0, parts.length - 1);
      id += parts[index];
    }
    return id;
  }

  generateRandomNumber(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  async updateProject() {
    this.projectDataService.updateProjectStatus = true;
    const assignMember = this.projectDataService.allocatedResource;
    const projectData = this.projectDataService.projectInformation;
    let Project = this.parseService.instance.Object.extend('Project');
    let projectQuery = new this.parseService.instance.Query(Project);
    projectQuery.equalTo('objectId', this.projectId);
    let result = await projectQuery.find();
    let updateProjectInfo = result[0];
    let projectInfo = updateProjectInfo.attributes.projectInfo;
    projectInfo.projectName = projectData.projectName.value;
    projectInfo.clientName = projectData.clientName.value;
    projectInfo.projectDescription = projectData.projectDescription.value;
    const details = [];
    const resourceGroup = await this.constructResource(assignMember, 'role');
    for (const [key, value] of Object.entries(resourceGroup)) {
      let hoursMonth = 0;
      resourceGroup[key].forEach(element => {
        let data = element.hours ? element.hours : element.months;
        return hoursMonth = hoursMonth + data;
      });

      const detailsObject = {
        "id": this.getRandomNumber(9),
        "role": key,
        "count": resourceGroup[key].length,
        "hours": hoursMonth
      }
      details.push(detailsObject)

    }
    this.resourceDetails['details'] = details;
    updateProjectInfo.set('resourceDetails', this.resourceDetails);
    updateProjectInfo.set('projectInfo', projectInfo);
    updateProjectInfo.set('assignMember', assignMember);
    updateProjectInfo.save();
    await this.updateProjectMember();
    this.toastr.success('Project update and Members Assigned Successfully');
  }

  async updateProjectMember() {
    const assignMember = this.projectDataService.allocatedResource;
    const selectedBilling = this.projectDataService.selectedBilling;
    assignMember.forEach(async element => {
      if (element.isCreatedNew === true) {
        await this.getUser(element);
        let ProjectClass = this.parseService.instance.Object.extend('ProjectMembers');
        var projectDetails = new ProjectClass();
        projectDetails.set('project', { __type: 'Pointer', className: 'Project', objectId: this.projectId });
        projectDetails.set('startDate', new Date());
        projectDetails.set('endDate', new Date());
        projectDetails.set('resourcesType', selectedBilling.value);
        projectDetails.set('username', this.userName);
        projectDetails.set('isActive', true);
        projectDetails.set('isInvited', false);
        projectDetails.set('status', 'Assigned');
        projectDetails.set('role', element.role);
        projectDetails.set('tenantId', this.tenantId);
        projectDetails.set('user', { __type: 'Pointer', className: '_User', objectId: this.userId });
        projectDetails.save();
      }
    });

  }

}
